import { Link } from "react-router"

import { ForgotPasswordForm } from "@repo/ui/components/auth-forms"

import { AuthLayout } from "@/components/auth-layout"
import { authClient } from "@/lib/auth-client"

export function ForgotPasswordPage() {
  return (
    <AuthLayout>
      <ForgotPasswordForm
        backLink={
          <Link
            to="/login"
            className="text-muted-foreground underline-offset-4 hover:underline"
          >
            Back to sign in
          </Link>
        }
        onSubmit={async (email) => {
          const { error } = await authClient.requestPasswordReset({
            email,
            redirectTo: `${window.location.origin}/reset-password`,
          })

          return error ? (error.message ?? "Something went wrong") : null
        }}
      />
    </AuthLayout>
  )
}
